import { cx } from "@emotion/css";
import Collapse from "library/Molecules/Collapse";
import PropTypes from "prop-types";
import styles from "./styles";

const FlatBoxLayout = ({ className, children, color, collapse, ...restProps }) => (
  <div
    className={cx(
      "position-relative",
      ...(!collapse ? [styles.layout, className, "d-flex p-3 text-fs-10"] : []),
      `border-rounded bg-color-${color}`
    )}
    {...restProps}
  >
    {collapse ? (
      <Collapse className={cx(className, "p-3")} collapsedSize={300} color={color} {...restProps}>
        {children}
      </Collapse>
    ) : (
      children
    )}
  </div>
);

FlatBoxLayout.defaultProps = {
  className: null,
  color: "grey100",
  collapse: false,
};

FlatBoxLayout.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  color: PropTypes.oneOf(["primary", "grey100", "warning"]),
  collapse: PropTypes.bool,
};

export default FlatBoxLayout;
